// extracted by mini-css-extract-plugin
export var sliderRange = "_m0-2";
export var sliderRoot = "_m0-0";
export var sliderThumb = "_m0-3";
export var sliderTrack = "_m0-1";